import * as React from "react"
import { array, object, string, number } from "yup"
import { Grid, TextField } from "@mui/material"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import {AutocompleteAjaxSeeker, DrawerSeeker, SelectSeeker} from "@ui-seeker/core"
import {isEmpty} from '@ui-seeker/utils'

import {DIPSite, DIPCountry} from "@components";
import {BACKEND_APIS} from "@constants";
import {retailer} from "@signals";
import {useKeywordsDrawer} from "./@hooks";
import {keywordFilters} from "../@signals";
import {KEYWORD_TYPE_OPTIONS} from "./@constants";


export default function KeywordDrawer() {

    const { showToast } = useAppToast()
    const { keywordFormFilters, handleKeywordUpdate, tableTile, isCreateMode, isAssociateMode } = useKeywordsDrawer()

    const validatorData = useValidatorSeeker({
        keywordName: keywordFormFilters.value?.keywordName,
        keywordType: keywordFormFilters.value?.keywordType,
        customerID: keywordFormFilters.value?.customerID,
        keywordID: keywordFormFilters.value?.keywordID,
        categoryID: keywordFormFilters.value?.categoryID,
        siteID: retailer.value
    }, object({
        ...!isAssociateMode && {
            keywordName: string().required('Keyword Name must be provided'),
            keywordType: number().required('Keyword Type must be provided'),
            categoryID: number().required('One Category must be provided')
        },
        ...(isCreateMode || isAssociateMode) && {
            customerID: number().required('One Customer must be provided'),
            siteID: array().min(1, 'One site must be selected')
        },
        ...isAssociateMode && {
            keywordID: number().required('One Keyword must be provided'),
        }
    }))

    const drawerProps = {
        title: tableTile,
        isOpen: !isEmpty(keywordFilters.value),
        controller: () => {
            keywordFilters.value = {}
        },
        successProps: {
            onClick: isEmpty(validatorData.errors)
                ? () => {
                    handleKeywordUpdate()
                    keywordFilters.value = {}
                }
                : () => {
                    showToast.warning('Please ensure all mandatory fields are completed')
                }
        }
    }

    const isDrawerActive = !isEmpty(keywordFilters.value);
    debugger
    return <DrawerSeeker {...drawerProps}>
        <Grid container spacing={2}>

            {!isAssociateMode && <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Keyword Name"
                    size="small"
                    value={keywordFormFilters.value?.keywordName}
                    onChange={e => {
                        keywordFormFilters.value = {...keywordFormFilters.value, keywordName: e.target.value}
                    }}
                    sx={{ mt: 3, mb: 1 }}
                    helperText={!!isDrawerActive && validatorData.errors?.keywordName}
                    error={!!isDrawerActive && !!validatorData.errors?.keywordName}
                />
            </Grid>}

            {!isAssociateMode && <Grid item xs={12}>
                <SelectSeeker
                    options={KEYWORD_TYPE_OPTIONS}
                    value={keywordFormFilters.value?.keywordType}
                    onChange={(e) => {
                        keywordFormFilters.value = {...keywordFormFilters.value, keywordType: e.target.value}
                    }}
                    label="Keyword Type"
                    multiple={false}
                    sx={{ mb: 1 }}
                    error={validatorData.errors?.keywordType}
                />
            </Grid>}

            {!isAssociateMode && <Grid item xs={12}>
                <AutocompleteAjaxSeeker
                    urlAjax={`${BACKEND_APIS.MASTER_DATA}/category/options-customer`}
                    label="Category"
                    value={keywordFormFilters.value?.categoryID}
                    placeholder="All Categories"
                    onChange={(e) => {
                        keywordFormFilters.value = {...keywordFormFilters.value, categoryID: e.target.value}
                    }}
                    filters={{ customerID: keywordFormFilters.value?.customerID }}
                    multiple={false}
                    error={validatorData.errors?.categoryID}
                />
            </Grid>}

            {!!isAssociateMode && <Grid item xs={12}>
                <AutocompleteAjaxSeeker
                    urlAjax={`${BACKEND_APIS.MANAGEMENT}/keywords/keyword-options`}
                    label="Keyword"
                    value={keywordFormFilters.value?.keywordID}
                    placeholder="All Keywords"
                    onChange={(e) => {
                        keywordFormFilters.value = {...keywordFormFilters.value, keywordID: e.target.value}
                    }}
                    multiple={false}
                    error={validatorData.errors?.keywordID}
                />
            </Grid>}

            {(!!isCreateMode || !!isAssociateMode) && <Grid item xs={12}>
                <AutocompleteAjaxSeeker
                    urlAjax={`${BACKEND_APIS.MANAGEMENT}/keywords/customer-options`}
                    label="Customer"
                    value={keywordFormFilters.value?.customerID}
                    placeholder="All Customers"
                    onChange={(e) => {
                        keywordFormFilters.value = {...keywordFormFilters.value, customerID: e.target.value}
                    }}
                    multiple={false}
                    error={validatorData.errors?.customerID}
                />
            </Grid>}

            {(!!isCreateMode || !!isAssociateMode) && <Grid item xs={12}>
                <DIPCountry
                    urlAjax={`${BACKEND_APIS.MASTER_DATA}/site/market-customer-options`}
                    value={keywordFormFilters.value?.country}
                    onChange={(e) => {
                        keywordFormFilters.value = {...keywordFormFilters.value, country: e.target.value}
                    }}
                    sx={{ mb: 1 }}
                    filters={{ customerID: keywordFormFilters.value?.customerID }}
                    multiple={false}
                />
            </Grid>}

            {(!!isCreateMode || !!isAssociateMode) && <Grid item xs={12}>
                <DIPSite
                    urlAjax={`${BACKEND_APIS.MASTER_DATA}/site/customer-options`}
                    filters={{ customerID: keywordFormFilters.value?.customerID, country: keywordFormFilters.value?.country  }}
                    multiple
                    sx={{ mb: 1 }}
                    error={validatorData.errors?.siteID}
                />
            </Grid>}

        </Grid>
    </DrawerSeeker>
}